export class MapForm {
  map;
  userMarker;
  latitude;
  longitude;
  markerImgUrl;
  locationIqPublicMapApiKey;
  geoLocationValues;
  inputLatitude;
  inputLongitude;
  #mapElementId = 'geo-address-map';

  constructor(locationIqPublicMapApiKey, markerImgUrl, latitude, longitude) {
    this.locationIqPublicMapApiKey = locationIqPublicMapApiKey;
    this.markerImgUrl = markerImgUrl;
    this.latitude = latitude;
    this.longitude = longitude;
    this.inputLatitude = document.getElementById('input-geo-latitude');
    this.inputLongitude = document.getElementById('input-geo-longitude');
  }

  initMap() {
    if (this.map) {
      this.map.center = [this.latitude, this.longitude];
    } else {
      const streets = L.tileLayer.Unwired({ key: this.locationIqPublicMapApiKey, scheme: 'streets' });

      this.map = L.map(this.#mapElementId, {
        center: [this.latitude, this.longitude],
        zoom: 14,
        maxZoom: 18,
        minZoom: 4,
        layers: [streets],
      });
      L.control.scale({ imperial: false }).addTo(this.map);

      $(`#${this.#mapElementId}`).css('background-image', 'none');
    }
  }

  createDraggableMarker() {
    this.map.setView(L.latLng(this.latitude, this.longitude));

    if (this.userMarker) {
      this.userMarker.setLatLng(L.latLng(this.latitude, this.longitude));
    } else {
      const icon = L.icon({
        iconUrl: this.markerImgUrl,
        iconSize: [60, 60],
        iconAnchor: [20, 55],
      });

      this.userMarker = L.marker(new L.LatLng(this.latitude, this.longitude), { draggable: true, autoPan: true, icon });
      this.userMarker.addTo(this.map);

      this.inputLatitude.value = this.latitude;
      this.inputLongitude.value = this.longitude;
    }
  }

  fillGeoLocationValues() {
    const address = this.geoLocationValues.address || {};
    const result = this.geoLocationValues.result || {};
    $('#input-geo-street').val(result.address);
    $('#geo-address-city-input').val(result.city || address.city || address.name);
    $('#input-geo-zip').val(result.postcode);

    $('#input-geo-route').val(result.address);
    $('#input-geo-administrative-area-level-1').val(address.suburb);
    $('#input-geo-administrative-area-level-2').val(address.state);
    $('#input-geo-country').val(address.country_code);
    $('#input-geo-locality').val(address.city || address.name);
    $('#input-geo-postal-code').val(result.postcode || address.postcode);
    $('#input-geo-street-number').val(address.house_number);
    $('#input-geo-latitude').val(this.geoLocationValues.lat);
    $('#input-geo-longitude').val(this.geoLocationValues.lon);

    // For city form
    $('#input-geo-city').val(address.city || address.municipality || address.town);
    $('#input-geo-county').val(address.county || address.city_district);
  }

  markerMovedCallback() {
    this.userMarker.on('moveend', (e) => {
      const latLng = e.sourceTarget._latlng;
      this.inputLatitude.value = latLng.lat;
      this.inputLongitude.value = latLng.lng;
    });
  }
}
